module.exports = {"SEARCH_PLACEHOLDER":"Search...","SEARCH_FILTER_DEFAULT_TEXT":"All campaigns"}